function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component, whenever its content updates, traverses the DOM to find
 * semantic words and send the corresponding DOMRanges to the caller via a
 * callback.
 *
 * A "word" here is a sequence of non-whitespace text characters, uninterrupted
 * by the start/end of a non-inline element. That is, a word can span across
 * text nodes and inline tags like <b>, but cannot span across block
 * paragraphs.
 *
 * The words yielded by WordIndexer are sorted in document order, which makes
 * them amenable to binary search - see `findBoundaryWordIndex` in ranges.js.
 */
var React = require("react");

var babelPluginFlowReactPropTypes_proptype_DOMRange = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMRange || require("react").PropTypes.any;

var WordIndexer = function (_React$PureComponent) {
    _inherits(WordIndexer, _React$PureComponent);

    function WordIndexer() {
        _classCallCheck(this, WordIndexer);

        return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }

    /* eslint-enable react/sort-comp */

    /* eslint-disable react/sort-comp */
    WordIndexer.prototype.componentDidMount = function componentDidMount() {
        this._sendWordsUpdate();
    };

    WordIndexer.prototype.componentDidUpdate = function componentDidUpdate() {
        this._sendWordsUpdate();
    };

    WordIndexer.prototype._sendWordsUpdate = function _sendWordsUpdate() {
        this.props.onWordsUpdate(this._getWordRanges());
    };

    WordIndexer.prototype._getWordRanges = function _getWordRanges() {
        var container = this._container;

        if (!container) {
            throw new Error("invariant violation: `this._container` is not defined, but " + "this method is only called after mount/update");
        }

        // Create a TreeWalker that visits text nodes and element nodes.
        // We select the types of nodes we're interested in by bitwise-ORing
        // the desired filters together.
        var treeWalker = container.ownerDocument.createTreeWalker(container, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, function () {
            return NodeFilter.FILTER_ACCEPT;
        }, false);

        // Traverse the container's descendant text nodes in DOM order,
        // indexing the words we find.
        var index = [];
        var trailingWordRange = null;
        while (treeWalker.nextNode()) {
            var node = treeWalker.currentNode;

            if (node.nodeType === Node.ELEMENT_NODE) {
                var element = node;
                if (getComputedStyle(element).display !== "inline") {
                    // Block-level elements interrupt text words, so set the
                    // current trailing word to `null`.
                    //
                    // This includes exiting one paragraph to visit another,
                    // but also includes text interrupted by inline-block
                    // elements.
                    //
                    // TODO(mdr): Is this behavior *generalizably* correct?
                    // TODO(mdr): I don't *fully* understand the performance
                    //     implications of `getComputedStyle`, but I think it's
                    //     gonna be nbd at the current call sites. If we try to
                    //     generalize to frequently-updating content, we might
                    //     want to watch this as a potential performance
                    //     bottleneck.
                    trailingWordRange = null;
                }
            } else if (node.nodeType === Node.TEXT_NODE) {
                var text = node.nodeValue;

                // A "word" is here simply defined as a maximal-length
                // substring of non-space characters.
                //
                // Loop over all the words in the string, by repeatedly calling
                // `wordPattern.exec(text)`.
                var wordPattern = /\S+/g;
                var wordMatch = void 0;
                var newTrailingWordRange = null;
                while ((wordMatch = wordPattern.exec(text)) !== null) {
                    var startOffset = wordMatch.index;
                    var endOffset = wordMatch.index + wordMatch[0].length;

                    var range = void 0;
                    if (startOffset === 0 && trailingWordRange) {
                        // This word is at the start of this text node, and
                        // there's a trailing word from the previous text node,
                        // and there was no non-inline element between them.
                        // This word and the trailing word are probably
                        // intended to be two parts of the same word.
                        //
                        // So, instead of creating a new word range, we add
                        // this word to the previous range by extending it.
                        range = trailingWordRange;
                        range.setEnd(node, endOffset);
                    } else {
                        // Otherwise, start a new word range here, and add it
                        // to the list.
                        range = node.ownerDocument.createRange();
                        range.setStart(node, startOffset);
                        range.setEnd(node, endOffset);
                        index.push(range);
                    }

                    if (endOffset === text.length) {
                        newTrailingWordRange = range;
                    }
                }
                trailingWordRange = newTrailingWordRange;
            }
        }

        return index;
    };

    WordIndexer.prototype.render = function render() {
        var _this2 = this;

        return React.createElement(
            "div",
            { ref: function ref(container) {
                    return _this2._container = container;
                } },
            this.props.children
        );
    };

    return WordIndexer;
}(React.PureComponent);

WordIndexer.propTypes = {
    children: require("react").PropTypes.any,
    onWordsUpdate: require("react").PropTypes.func.isRequired
};


module.exports = WordIndexer;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/highlighting/word-indexer.jsx
 ** module id = 299
 ** module chunks = 0 1
 **/